import api from './client';

export interface OrgTag {
  id: string;
  org_id: string;
  name: string;
  color: string;
  scope: string; // ordre, dossier, vehicle
  active: boolean;
}

export type TagCreate = Omit<OrgTag, 'id'>;
export type TagUpdate = Partial<Omit<OrgTag, 'id' | 'org_id'>>;

export const tagsApi = {
  list: async (orgId: string, scope?: string): Promise<OrgTag[]> => {
    const { data } = await api.get('/tags', { params: { org_id: orgId, scope } });
    return data;
  },

  create: async (tag: TagCreate): Promise<OrgTag> => {
    const { data } = await api.post('/tags', tag);
    return data;
  },

  update: async (id: string, updates: TagUpdate): Promise<OrgTag> => {
    const { data } = await api.patch(`/tags/${id}`, updates);
    return data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/tags/${id}`);
  },
};
